var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Logo from '../../authenticated/shared/logo/Logo';
import { NavLinks } from './Navigations';
import { Chip } from '@mui/material';
import { appUrls } from "../../../urls";
var MobileSidebar = function () {
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ px: 3 }, { children: _jsx(Logo, {}) })), _jsx(Box, __assign({ p: 3 }, { children: _jsxs(Stack, __assign({ direction: "column", spacing: 2 }, { children: [NavLinks.map(function (navlink, i) { return (_jsxs(Button, __assign({ color: "inherit", href: navlink.to, sx: {
                                justifyContent: 'start',
                            } }, { children: [navlink.title, ' ', navlink.free ? (_jsx(Chip, { label: "Free!", size: "small", sx: {
                                        ml: '6px',
                                        borderRadius: '8px',
                                        color: 'primary.main',
                                        backgroundColor: 'rgba(93, 135, 255, 0.15)',
                                    } })) : null] }), i)); }), _jsx(Button, __assign({ color: "primary", variant: "contained", href: appUrls.auth.LOGIN }, { children: "Sign in" }))] })) }))] }));
};
export default MobileSidebar;
